"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const domain = process.env.VUE_APP_DOMAIN || process.env.DOMAIN || 'api.golfguru.io';
const baseURL = `https://${domain}`;
const timeout = process.env.VUE_APP_TIMEOUT || process.env.TIMEOUT || '4000';
exports.default = axios_1.default.create({
    baseURL,
    timeout: Number(timeout),
    headers: {
        Accept: 'application/json',
    },
});
